import { store } from '../redux/store';

function getReduxState() {
  return store.getState();
}

const areValidSimulationData = (simulationData) => {
  const { purpose, amount, payment, numberOfInstallments, TAN, TAEG, others } = simulationData;

  if (
    purpose?.index &&
    purpose?.icon &&
    purpose?.text &&
    purpose?.code &&
    amount?.current &&
    amount?.min &&
    amount?.max &&
    payment?.current &&
    payment?.min &&
    payment?.max &&
    numberOfInstallments?.min &&
    numberOfInstallments?.max &&
    TAN?.min &&
    TAN?.max &&
    TAEG?.min &&
    TAEG?.max &&
    (
      others?.transparencyDuty &&
      typeof others.transparencyDuty === "number" ? others.transparencyDuty >= 0 : true
    ) &&
    (
      others?.administrationFees &&
      typeof others.administrationFees === "number" ? others.administrationFees >= 0 : true
    ) &&
    (
      others?.administrationFeesMax &&
      typeof others.administrationFeesMax === "number" ? others.administrationFeesMax >= 0 : true
    ) &&
    (
      others?.stampDuty &&
      typeof others.stampDuty === "number" ? others.stampDuty >= 0 : true
    ) &&
    (
      others?.stampDutyMax &&
      typeof others.stampDutyMax === "number" ? others.stampDutyMax >= 0 : true
    )
  ) {
    return true;
  }

  return false;
}

export const handleFlow = (currentLocation) => {
  switch (currentLocation) {
    case '/risultato-profilo-web.html': {
      const { table, currentSimulation, skip } = getReduxState();

      if (areValidSimulationData(currentSimulation) && ((Array.isArray(table['complete']) && table['complete'].length) || skip.simulation)) {
        return true;
      }

      return false;
    }
    default:
      return false;
  }
}